import { type AcademyDetails, normalisePhone } from '@musicville/shared';
import { useAcademyDetails } from './queries';

export const ACADEMY = {
  name: 'MusicVille Academy',
  email: 'hello@musicville.az',
  phoneDisplay: '+994 50 123 45 67',
  phoneE164: '+994501234567',
  landlineDisplay: '+994 12 345 67 89',
  landlineE164: '+994123456789',
  address: '28 May küç. 12, Baku',
  timezone: 'Asia/Baku',
  trialMinutes: 30,
  get whatsappUrl(): string {
    return `https://wa.me/${this.phoneE164.replace('+', '')}`;
  },
  get mapUrl(): string {
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(this.address)}`;
  },
  openingHours: [
    { days: 'Monday – Saturday', hours: '10:00 – 21:00' },
    { days: 'Sunday', hours: 'closed' },
  ],
} as const;

export interface AcademyContact {
  name: string;
  email: string;
  phoneDisplay: string;
  phoneE164: string;
  address: string;
  whatsappUrl: string;
  mapUrl: string;
  legalDraft: boolean;
}

export function academyContact(details: AcademyDetails | undefined): AcademyContact {
  const phoneDisplay = details?.phone ?? ACADEMY.phoneDisplay;
  const phoneE164 = details?.phone ? normalisePhone(details.phone) : ACADEMY.phoneE164;
  const address = details?.address ?? ACADEMY.address;
  return {
    name: details?.name ?? ACADEMY.name,
    email: details?.email ?? ACADEMY.email,
    phoneDisplay,
    phoneE164,
    address,
    whatsappUrl: `https://wa.me/${phoneE164.replace('+', '')}`,
    mapUrl: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`,
    legalDraft: details?.legalDraft ?? true,
  };
}

export function useAcademy(): AcademyContact {
  const { data } = useAcademyDetails();
  return academyContact(data);
}
